// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1EX8J","title":"Header_title__1rLpn","side":"Header_side__1mTAw"};